"use client";
import { useState } from "react";

export default function GlobalError({ error }) {
  const [triedReloading] = useState(() => {
    try {
      const reload =
        document.cookie
          .split("; ")
          .find(row => row.startsWith("reload="))
          ?.split("=")[1] || null;

      if (reload === null) {
        console.error(error);

        document.cookie = `reload=true;expires=${new Date(
          Date.now() + 10 * 60e3
        ).toUTCString()};path=/`;

        window.location.reload();
        // This won't execute due to reload, but for clarity
        return false;
      }

      return true; // Cookie exists, show error UI
    } catch (error) {
      console.error("Cookie access failed:", error);

      return true; // Show error UI as fallback
    }
  });

  return triedReloading ? (
    <html>
      <body>
        <h2>Something went wrong!</h2>
      </body>
    </html>
  ) : null;
}
